import { toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, _toDisplayString(_ctx.name1), 1),
    _createVNode("div", null, _toDisplayString(_ctx.name2), 1),
    _createVNode("div", null, _toDisplayString(_ctx.$data), 1),
    _createVNode("div", null, _toDisplayString(_ctx.$props), 1)
  ], 64))
}